import { usePathname, useSearchParams } from 'next/navigation'

type RemoveSearchParamsOptions = {
  /**
   * Allows to push the new URL to the history stack.
   */
  pushState?: boolean
}

export function useRemoveSearchParams() {
  const searchParams = useSearchParams()
  const pathname = usePathname()

  const removeSearchParams = (
    paramsToRemove: string | string[],
    options: RemoveSearchParamsOptions,
  ) => {
    const params = new URLSearchParams(searchParams)
    const paramToRemoveArray = Array.isArray(paramsToRemove)
      ? paramsToRemove
      : [paramsToRemove]

    for (const paramToRemove of paramToRemoveArray) {
      params.delete(paramToRemove)
    }

    const newPath = params.toString()
      ? `${pathname}?${params.toString()}`
      : pathname

    if (options.pushState) {
      window.history.pushState(
        null,
        '',
        `${pathname}?${searchParams.toString()}`,
      )
    }

    window.history.replaceState(null, '', newPath)
  }

  return removeSearchParams
}
